import { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from "@workos-inc/authkit-react";

import { BRAND } from '../../shared/theme/paletteDark';

export default function SignupRedirectPage() {
  const { signUp } = useAuth();

  useEffect(() => {
    signUp();
  }, [signUp]);

  return (
    <Box sx={{ flex: 1, display: 'grid', placeItems: 'center' }}>
      <CircularProgress sx={{ color: BRAND.parchment }} />
      <Typography variant="body1" sx={{ fontSize: 15, color: BRAND.parchment }}>Redirecting...</Typography>
    </Box>
  );
}
